import { showErrorToast, showSuccessToast } from "@src/appV2/lib/Notifications";
import { LoadingButton } from "@src/lib/ui-react";

import { useSyncWorkerWithZendesk } from "../apis/useSyncWorkerWithZendesk";

interface SyncWorkerWithZendeskProps {
  workerId: string;
}

export function SyncWorkerWithZendeskButton(props: SyncWorkerWithZendeskProps) {
  const { workerId } = props;

  const { mutateAsync, isLoading } = useSyncWorkerWithZendesk({
    onSuccess: () => {
      showSuccessToast("Successfully synced with Zendesk");
    },
    onError: (error) => {
      const errorMessage: string = error instanceof Error ? error.message : String(error);
      showErrorToast(`Failed to sync to Zendesk: ${errorMessage}`);
    },
  });

  return (
    <LoadingButton
      variant="outlined"
      isLoading={isLoading}
      disabled={isLoading}
      onClick={() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        mutateAsync({ workerId });
      }}
    >
      Sync Worker With Zendesk
    </LoadingButton>
  );
}
